export class AccountOnboarding {
	public userInformationReady: boolean
	public brandProfileReady: boolean
	public firstZoneReady: boolean
	public musicAssignmentReady: boolean
	public downloadReady: boolean

	constructor(data: {
		userInformationReady: boolean
		brandProfileReady: boolean
		firstZoneReady: boolean
		musicAssignmentReady: boolean
		downloadReady: boolean
	}) {
		this.userInformationReady = data.userInformationReady
		this.brandProfileReady = data.brandProfileReady
		this.firstZoneReady = data.firstZoneReady
		this.musicAssignmentReady = data.musicAssignmentReady
		this.downloadReady = data.downloadReady
	}

	static create(data: Partial<AccountOnboarding>): AccountOnboarding {
		const defaults = {
			userInformationReady: false,
			brandProfileReady: false,
			firstZoneReady: false,
			musicAssignmentReady: false,
			downloadReady: false,
		}

		return new AccountOnboarding({
			...defaults,
			...data,
		})
	}
}
